import React, {FC} from "react"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import onEnter from "@irati/utils/onEnter"
import {Body, H3} from "@irati/ui/src/Typography"

import {CommunicationPreferences} from "./types"
import {GradientCard, SpanLink} from "./styled/Banner"

interface Props extends InjectIntl {
  onClickUnsubscribe: (preference: keyof CommunicationPreferences) => void,
  preference?: keyof CommunicationPreferences
}

const Banner: FC<Props> = ({preference, onClickUnsubscribe, formatMessage}) => {
  const getText = () => {
    switch (preference) {
      case "free_perks":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.freePerks"})
      case "weekly_newsletter":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.weeklyNewsletter"})
      case "recognition_alerts":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.recognitionAlerts"})
      case "wellness_alerts":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.wellnessAlerts"})
      case "hr_tips":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.hrTips"})
      case "product_content":
        return formatMessage({id: "platform.contactPreferences.banner.communicationType.productContent"})
      default:
        return undefined
    }
  }

  const handleUnsubscribe = () => {
    if (preference) {
      onClickUnsubscribe(preference)
      window.scrollTo({top: 400, behavior: "smooth"})
    }
  }

  const formattedPreference = getText()

  if (!formattedPreference) return null

  return (
    <GradientCard medium>
      <H3 color="white" marginBottom={2}>
        <FormattedMessage
          id="platform.contactPreferences.banner.header"
          values={{communicationPreference: <strong>{formattedPreference}</strong>}} />
      </H3>
      <Body color="white">
        <FormattedMessage
          id="platform.contactPreferences.banner.body"
          values={{
            link: (
              <SpanLink onClick={handleUnsubscribe} onKeyDown={(e) => onEnter(e, handleUnsubscribe)}>
                <FormattedMessage id="platform.contactPreferences.banner.link" />
              </SpanLink>
            )
          }} />
      </Body>
    </GradientCard>
  )
}

export default injectIntl<Props>(Banner)
